import moment from 'moment'

var field = {
  width: '100px',
  display: 'inline-block',
  paddingRight: '6px',
  textAlign: 'left'
}

export const data = () => ({
  audienceTypeList: [],
  fullList: [],
  data: [],
  name: '',
  recipientsSelected: [],
  ownerIdsSelected: [],
  isFiltering: false,
  query: null,
  selected: null,
  isReadOnly: false,
  formComplete: false,
  formData: {
    address: ''
  },
  loading: false,
  isDebug: true,
  toggle: false,
  completeToggle: false,
  openOnFocus: true,
  mailingTypeList: null,
  showPreview: false,
  showAttachments: false,
  showSelectedAudience: false,

  formatDateFn: function(value) {
    return value && value != undefined
      ? moment(value.toString(), 'YYYY/MM/DD HH:mm:ss')
          .format('MM-DD-YYYY')
          .toString()
      : ''
  },
  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    },
    amountField: Object.assign({}, field, {
      width: '125px'
    })
  }
})
